import React from "react";
import "./GameControlPassenger.css";
import { useWebSocket } from "../../context/WebSocketContext";
import Scale from "../Scale/Scale";
import Telegraph from "../Telegraph/Telegraph";
import Letter from "../Letter/Letter";
import Radio from "../Radio/Radio";
import Clock from "../Clock/Clock";
import Board from "../Board/Board";
import Immersion from "../Immersion/Immersion";
import Picture from "../Picture/Picture";

const GameControlPassenger = () => {
    const {
        connectionStatus,
        weight,
        weightsSolved,
        telegraphCurrentMessage,
        telegraphAllSolved,
        telegraphSubSolved,
        telegraphConnected,
        letterReadId,
        letterSolved,
        radioCurrentFreq,
        radioCurrentVol,
        radioCurrentCorrect,
        clockTime,
        clockAllSolved,
        solvedBoard,
        rfidEnabled,
        rfidDisabled,
        solvedRiddles,
        sendOverwriteMessage,
        immersionEvents,
        immersionConnected,
        pictureRelayTriggered,
        pictureSolved,
        pictureConnected
    } = useWebSocket();

    return (
        <div id="game-wrapper">
            {connectionStatus && (
                <>
                    <Immersion events={immersionEvents} connected={immersionConnected}/>
                    <Board solvedArray={solvedBoard} solvedRiddles={solvedRiddles} rfidEnabled={rfidEnabled} rfidDisabled={rfidDisabled} overWriteFunction={sendOverwriteMessage}></Board>
                    <Clock currentTime={clockTime} allSolved={clockAllSolved} overWriteFunction={sendOverwriteMessage} index={0}></Clock>
                    <Letter solved={letterSolved} readId={letterReadId} overWriteFunction={sendOverwriteMessage} index={1}></Letter>
                    <Telegraph telegraphCurrentMessage={telegraphCurrentMessage ?? []} allSolved={telegraphAllSolved} subSolved={telegraphSubSolved} connected={telegraphConnected} overWriteFunction={sendOverwriteMessage} index={2}/>
                    <Radio currentFreq={radioCurrentFreq} currentlyCorrect={radioCurrentCorrect} overWriteFunction={sendOverwriteMessage} index={3}></Radio>
                    <Picture solved={pictureSolved} relaySolved={pictureRelayTriggered} overWriteFunction={sendOverwriteMessage} pictureConnected={pictureConnected} index={5}></Picture>
                    <Scale weight={weight} scaleStatuses={weightsSolved ?? []} overWriteFunction={sendOverwriteMessage} index={4}/>
                </>
            )}
        </div>
    );
};

export default GameControlPassenger;